module.exports = __webpack_public_path__ + "img/des_happy_5.82c9547f.jpg";